// Module
var code = "<md-button aria-label=\"create order\" class=\"md-primary\" permission permission-only=\"['oms.orders.create']\" ui-sref=\"order-create\" layout=\"row\" layout-align=\"center center\"> <span class=\"br-body-2\" translate>Create Order</span> </md-button> ";
// Exports
export default code;